import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BasefieldV2Component } from '../basefield-v2/basefield-v2.component';

@Component({
  selector: 'currency-v2',
  templateUrl: './currency-v2.component.html',
  styleUrls: ['./currency-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyV2Component extends BasefieldV2Component {
  valueChange(value: number | null) {
    this.formControl.setValue(value);
    this.formControl.markAsDirty();
  }
}
